export default {
  tableTabs: [
    {
      title: "All Cryptocurrencies",
      id: 1
    },
    {
      title: "Favorites",
      id: 2
    }
  ],
  searchInputPlaceholder: "Search by currency name or symbol...",
  categoriesMenu: ["Most Popular", "Cheapest", "Most Expensive"],
  headers: [
    {
      text: "",
      align: "center",
      sortable: false,
      value: "fave",
      width: 70
    },
    {
      text: "#",
      align: "center",
      sortable: true,
      value: "rank",
      width: 70
    },
    {
      text: "Currency Name",
      align: "start",
      sortable: true,
      value: "name_locale"
    },
    {
      text: "Price (USD)",
      value: "price",
      align: "left",
      sortable: true
    },
    {
      text: "24h Changes",
      value: "daily_change_percent",
      align: "center",
      sortable: true
    },
    {
      text: "Our Selling Price (IRR)",
      value: "price_buy",
      align: "left",
      sortable: true
    },
    {
      text: "Our Buying Price (IRR)",
      value: "price_sell",
      align: "left",
      sortable: true
    },
    {
      text: "Market Cap (USD)",
      value: "market_cap",
      align: "left",
      sortable: true
    }
    /*{
          text: "Price Chart",
          value: "diagramPrice",
          align: "center",
          sortable: false
        },*/
    /*{ text: "Operations", value: "actions", align: "center", sortable: false }*/
  ],
  noResults: "No results found.",
  noResultsForFave: "Your favorites list is empty."
};
